import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ComponentRef,
  inject,
  input,
  OnDestroy,
  OutputEmitterRef,
  OutputRefSubscription,
  viewChild
} from '@angular/core';
import { NgComponentOutlet } from '@angular/common';
import { IModalButton, IModalData, ModalService } from '../../services/modal.service';

@Component({
  selector: 'ui-modal',
  imports: [
    NgComponentOutlet
  ],
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss',
  host: {
    '[class.modal-fullscreen]': 'data()?.styles?.fullscreen',
    '[class.modal-sidebar]': 'data()?.styles?.sidebar',
    '[class.no-backdrop]': 'data()?.styles?.noBackdrop',
    '[style.--fullscreen-top.px]': 'data()?.styles?.fullscreenTop || null',
    'animate.enter': 'modal-overlay-enter',
    'animate.leave': 'modal-overlay-leave',
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalComponent implements AfterViewInit, OnDestroy {
  readonly ngComponentOutlet = viewChild(NgComponentOutlet);
  readonly data = input<IModalData | null>(null);
  private modal = inject(ModalService);
  private subscriptions: OutputRefSubscription[] = [];

  ngAfterViewInit() {
    const ngComponentOutlet = this.ngComponentOutlet();
    if (ngComponentOutlet && ngComponentOutlet['_componentRef']?.instance) {
      ngComponentOutlet['_componentRef'].instance._modal = this;
      this.bindOutputs(ngComponentOutlet['_componentRef']);
    }
  }

  onButtonClick(btn: IModalButton, e: MouseEvent) {
    if (btn.click) {
      btn.click(btn, e, this.ngComponentOutlet()?.componentInstance);
    }
    const data = this.data();
    if (btn.close && data) {
      this.modal.close(data);
    }
  }

  close() {
    const data = this.data();
    if (!data) {
      return;
    }
    this.modal.close(data);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  private bindOutputs(comp: ComponentRef<any>) {
    const outputs = this.data()?.outputs;
    if (!outputs) {
      return;
    }
    for (const key in outputs) {
      if (comp.instance.hasOwnProperty(key) && (comp.instance[key] instanceof OutputEmitterRef)) {
        const sub = (comp.instance[key] as OutputEmitterRef<any>).subscribe((...args) => outputs[key](...args));
        this.subscriptions.push(sub);
      }
    }
  }
}
